var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{class:_vm.$style.gridList,attrs:{"data-test-id":_vm.$testId('useCaseList')}},_vm._l((_vm.useCases),function(useCase,index){return _c('li',{key:`${useCase.label}-${index}`,class:_vm.$style.item},[_c('UseCaseCard',{attrs:{"selected":_vm.selected,"useCase":useCase},on:{"click":_vm.handleClick}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }